
export const PageNotFound = () => {
    return (
        <div className="flx-col flx-cnt f-pg">
            <h1>Error 404</h1>
            <p>Page not found</p>
        </div>
    )
}